import { render } from "./action.vue?vue&type=template&id=13615c8a&scoped=true"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"

import "./action.vue?vue&type=style&index=0&id=13615c8a&lang=scss&scoped=true"
import "./action.vue?vue&type=style&index=1&id=13615c8a&lang=css"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13615c8a"]])

export default __exports__